import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isTenantUser } from '../../lib/authRoles';
import { RouteAuthSpinner } from './RouteAuthSpinner';
/** Legacy /dashboard, /properties, etc. — tenants go to portal, owners to /app/* */
export function LegacyAppRedirect({ ownerTo }) {
  const { user, loading } = useAuth();
  if (loading) return <RouteAuthSpinner />;
  if (isTenantUser(user)) {
    return <Navigate to="/app/tenant" replace />;
  }
  return <Navigate to={ownerTo} replace />;
}
